import React from 'react';
import { QUESTIONS_PER_ROUND } from '../utils/gameEngine';

const RoundHeader = ({ round, questionInRound, totalQuestion, totalQuestions, phase, isDailyChallenge, answers = [], score = 0 }) => {
  const isSuddenDeath = phase === 'sudden_death';
  const dotsCount = isDailyChallenge ? totalQuestions : QUESTIONS_PER_ROUND;

  const roundStartIndex = isDailyChallenge ? 0 : (round - 1) * QUESTIONS_PER_ROUND;
  const roundAnswers = answers.slice(roundStartIndex, roundStartIndex + dotsCount);

  const getDotClass = (i) => {
    const answered = roundAnswers[i];
    const isCurrent = i === questionInRound - 1;
    if (isCurrent) return 'round-dot current-dot';
    if (answered === undefined) return 'round-dot empty-dot';
    return answered.isCorrect ? 'round-dot correct-dot' : 'round-dot wrong-dot';
  };

  return (
    <div className="round-header">
      <div className="round-indicator">
        {isSuddenDeath ? (
          <span className="round-badge sudden-death">SUDDEN DEATH</span>
        ) : isDailyChallenge ? (
          <span className="round-badge">Daily Challenge</span>
        ) : (
          <span className="round-badge">Round {round}</span>
        )}
      </div>
      <div className="question-counter">
        {isSuddenDeath ? (
          <span>SD Question {questionInRound}</span>
        ) : (
          <span style={{ color: '#22c55e', fontWeight: 'bold', fontSize: '1.1rem' }}>
            {score} correct
          </span>
        )}
      </div>
      {!isSuddenDeath && (
        <div className="round-dots">
          {Array.from({ length: dotsCount }, (_, i) => (
            <span key={i} className={getDotClass(i)} />
          ))}
        </div>
      )}
    </div>
  );
};

export default RoundHeader;
